const DELIVERY_FORECAST_STATUSES = ['certidoes', 'taxas', 'laudemio'];
import {
  apiReferenceDate,
  displayReferenceDate,
  maskReferenceDate,
  referenceDateComplete,
} from './postSaleDate';

export const statusRequiresDeliveryForecast = status =>
  DELIVERY_FORECAST_STATUSES.includes(status);

export const maskDeliveryForecast = maskReferenceDate;
export const deliveryForecastDisplayValue = displayReferenceDate;
export const deliveryForecastApiValue = apiReferenceDate;
export const deliveryForecastComplete = referenceDateComplete;
